// TODO: UTILIZANDO MIN NO FUNCIONA MODAL DE BS!!!
window.$ = window.jQuery = require('jquery');

// Bootstrap
window.Popper = require('popper.js');
require('bootstrap/dist/js/bootstrap');

// Date time picker: https://getdatepicker.com/6/
window.tempusDominus = require('@eonasdan/tempus-dominus/dist/js/tempus-dominus');

// import { Calendar } from '@fullcalendar/core';
// import esLocale from '@fullcalendar/core/locales/es';

// No funciona... le di mil vueltas pero no parece funcionar
// const load_FullCalendar = require('@fullcalendar/core/index.global.js');
// console.log(load_FullCalendar);
// console.log(load_FullCalendar.default);

// window.Calendar_esLocale = require('@fullcalendar/core/locales/es.global.js');